export default function validatePhoneNumber(phoneno="") {
    var phonePattern = /^0[0-8][0-9]{8}$/g ;
    if (phonePattern.test(phoneno)) {
        return true;
    } else {
        return false;
    }
}
